import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SizeGuide } from '@app/shared/model/interfaces/sizeGuide/sizeGuide';

@Component({
  selector: 'vc-size-guide-modal',
  templateUrl: './size-guide-modal.component.html'
})
export class SizeGuideModalComponent implements OnInit {
  public size: string;
  public standard: string;
  public sizeGuide: SizeGuide;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.size = this.data.size;
    this.standard = this.data.standard;
    this.sizeGuide = this.data.sizeGuide;
  }
}
